import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-dialog',
  template: `<div class="modal hide" [class.show]="show">
              <div class="modal-dialog modal-dialog-centered modal-dialog-custom">
                <div class="modal-content modal-custom">
                  <span class="modal-header mb-3 justify-content-end icon-close-error" (click)="show = false" *ngIf="enableCloseDialogButton">
                    <img loading="lazy" data-src="{{ '/icons/Black/times.svg' | blobstorage }}" alt="About Title" src="{{ ''/icons/White/times-circle.svg' | blobstorage }}">
                  </span>
                   <div class="modal-body modal-custom-body">
                    <ng-content></ng-content>
                  </div>
                   <div class="modal-footer" *ngIf="enableConfirmButton">
                    <button type="button" class="btn btn btn-primary" data-dismiss="modal" (click)="show = false">{{ confirmButtonText }}</button>
                  </div>
                  <div class="modal-footer" *ngIf="hasCallBack">
                    <button class="btn btn-secondary" color="primary" (click)="show = false">Cancelar</button>
                    <button type="button" class="btn btn btn-primary" data-dismiss="modal" (click)="callBackFunction()">Confirmar</button>
                  </div>
                </div>
              </div>
            </div>`,
  styleUrls: ['./dialog.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DialogComponent implements OnChanges
{
  @Input() public enableCloseDialogButton: boolean = true;
  @Input() public enableConfirmButton: boolean = false;
  @Input() public confirmButtonText: string = "SAMPLE";
  @Input() public hasCallBack: boolean = false;
  @Input() public callBackFunction: any;

  @ViewChild('modal') private modal: ElementRef;

  /*Show/Hide*/
  @Output() public showChange = new EventEmitter<boolean>();

  private _show: boolean = false;

  @Input() public set show(show: boolean)
  {
    this._show = show;
    this.showChange.emit(this._show);
  }

  public get show(): boolean
  {
    return this._show;
  }

  private _preventCloseFromBackDrop: boolean = false;
  @Input() public set preventCloseFromBackDrop(preventCloseFromBackDrop: boolean)
  {
    this._preventCloseFromBackDrop = preventCloseFromBackDrop;
  }

  public get preventCloseFromBackDrop(): boolean
  {
    return this._preventCloseFromBackDrop;
  }

  constructor(private renderer: Renderer2)
  {
    this.renderer.listen('window', 'click', (e: Event) =>
    {
      if (e.target === this.modal?.nativeElement && !this._preventCloseFromBackDrop)
      {
        this.show = false;
        this.showChange.emit(this._show);
      }
    });
  }

  ngOnChanges(): void
  {
    this._show = this.show;
  }
}
